import { useEffect, useState } from "react";
import { api, type Outreach } from "../api";

export default function OutreachPage() {
  const [items, setItems] = useState<Outreach[]>([]);
  const [tab, setTab] = useState("draft");
  const [error, setError] = useState("");
  const [open, setOpen] = useState<number | null>(null);

  useEffect(() => {
    load(tab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  async function load(status: string) {
    setError("");
    try {
      setItems(await api.outreach(status === "all" ? undefined : status));
    } catch (e) {
      setError((e as Error).message);
    }
  }

  async function act(id: number, status: string) {
    try {
      await api.updateOutreach(id, { status });
      await load(tab);
    } catch (e) {
      setError((e as Error).message);
    }
  }

  return (
    <div>
      <h2>Outreach approval queue</h2>
      <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
        {["draft", "approved", "sent", "replied", "failed", "all"].map((s) => (
          <button key={s} className={tab === s ? "primary" : ""} onClick={() => setTab(s)}>
            {s}
          </button>
        ))}
      </div>
      {error && <p className="err">{error}</p>}
      {items.map((o) => (
        <div className="card" key={o.id}>
          <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
            <div>
              <b>{o.subject}</b>
              <span className="muted"> &middot; variant {o.variant}</span>
              <div className="muted">{o.search_name ?? "no search"} &middot; created {o.created_at}</div>
            </div>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <span className={`badge ${o.status}`}>{o.status}</span>
              {o.status === "draft" && (
                <>
                  <button className="primary" onClick={() => act(o.id, "approved")}>Approve</button>
                  <button className="danger" onClick={() => act(o.id, "failed")}>Reject</button>
                </>
              )}
              {o.status === "approved" && (
                <button onClick={() => act(o.id, "draft")}>Send back to draft</button>
              )}
              <button onClick={() => setOpen(open === o.id ? null : o.id)}>{open === o.id ? "Hide" : "View"}</button>
            </div>
          </div>
          {open === o.id && <div className="detail" style={{ marginTop: 12 }}>{o.body}</div>}
        </div>
      ))}
      {items.length === 0 && <p className="muted">No outreach with status “{tab}”.</p>}
    </div>
  );
}